type Status =
  | "running"
  | "approval"
  | "takeover"
  | "failed"
  | "success"
  | "human"
  | "queued";

interface Props {
  status: Status;
  label: string;
}

const classes: Record<Status, string> = {
  running: "bg-status-running-bg text-status-running",
  approval: "bg-status-approval-bg text-status-approval",
  takeover: "bg-status-takeover-bg text-status-takeover",
  failed: "bg-status-failed-bg text-status-failed",
  success: "bg-status-success-bg text-status-success",
  human: "bg-status-human-bg text-status-human",
  queued: "bg-status-queued-bg text-status-queued",
};

export function StatusPill({ status, label }: Props) {
  return (
    <span
      className={[
        "inline-flex items-center gap-1.5 rounded-pill px-2 py-0.5 text-xs",
        classes[status],
      ].join(" ")}
    >
      <span
        aria-hidden
        className={[
          "h-1.5 w-1.5 rounded-full",
          status === "running" ? "animate-pulse" : "",
          `bg-status-${status}`,
        ].join(" ")}
      />
      <span>{label}</span>
    </span>
  );
}
